module.exports = "/_next/static/images/Firmware@3x-cb741e5075d079bacf9364dee2519604.png";